import React from 'react'
import './flag.css'

export default(props)=>{
  const {code,className} = props
  if (typeof(code)==='string'&&code.length>0) {
    return (
      <span className={`flag-icon flag-icon-${code.toLowerCase()} ${className||''}`}></span>
    )
  }
  return null
}
